import React, { useEffect, useMemo } from "react";
import {
	createBrowserRouter,
	createRoutesFromElements,
	RouterProvider,
} from "react-router";
import { useSelector } from 'react-redux'
import { createAppRouteElements } from "./routes/index"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './assets/css/theme.css'
import './assets/css/bootstrap.css'
import './assets/css/bootstrap-override.css'
import './assets/css/topbar.css'
import './assets/css/verical.css'
import './assets/css/datepicker.css'
import './assets/css/forms.css'
import "./assets/css/react-datepicker.css"
import './assets/css/periodPicker.css'
import './assets/css/style.css'
import './assets/css/delivery.css'
import './assets/css/analytics-filter.css'
import './assets/css/chain-reports.css'
import './assets/css/olap.css'
import './assets/css/font.css'
import './assets/css/iconscout.css'

function App() {
	const loader = useSelector(state => state.loader)

	// Роутер один на всё приложение — не пересоздавать при login/logout, иначе navigate теряется
	const router = useMemo(
		() =>
			createBrowserRouter(
				createRoutesFromElements(createAppRouteElements()),
				{
					future: {
						v7_relativeSplatPath: true,
						v7_fetcherPersist: true,
						v7_normalizeFormMethod: true,
						v7_partialHydration: true,
						v7_skipActionErrorRevalidation: true,
					},
				}
			),
		[]
	)

	const onStorageChange = (event) => {
		if (event.key === 'token') {
			// console.log('Old value:', event.oldValue);
			// console.log('New value:', event.newValue);
			if (event.newValue === null) {
				window.location.reload();
			}
		}
	};

	useEffect(() => {
		document.addEventListener("wheel", function (event) {
			if (document.activeElement.type === "number") {
				document.activeElement.blur();
			}
		});
		document.addEventListener("keypress", function (event) {
			var invalidChars = ["+", "e"];
			if (document.activeElement.type === "number" && invalidChars.includes(event.key)) {
				event.preventDefault();
			}
		});

		window.addEventListener('storage', onStorageChange);
		return () => {
			window.removeEventListener('storage', onStorageChange);
		};
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<RouterProvider router={router} />

			<ToastContainer
				position="bottom-left"
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				theme="colored"
			/>

			{loader &&
				<div id="loading-bg">
					<div className="loading">
						<div className="effect-1 effects"></div>
						<div className="effect-2 effects"></div>
						<div className="effect-3 effects"></div>
					</div>
				</div>
			}
		</>
	);
}

export default App;
